import { motion } from "framer-motion";
import { useServiceRequestsByFacilityId } from "modules/service-requests/serviceRequestHooks";
import { useGetCurrentLocalFacilityId } from "modules/facility/facilityHooks";
import { serviceRequestAlerts } from "ui-modules/nav/navSlice";
import { useAppDispatch } from "utils/hooks";
import ServiceRequestIcon from "components/svg/ServiceRequestIcon";
import { Badge } from "@/components/ui/badge";

const ServiceRequestAlert: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const currentFacilityId = useGetCurrentLocalFacilityId();

  const [currentFacilityServiceReqests] =
    useServiceRequestsByFacilityId(currentFacilityId);

  const setAlertsTray = (value: boolean) => {
    dispatch(serviceRequestAlerts({ isOpen: value }));
  };

  const currentRequests = currentFacilityServiceReqests.length ? true : false;

  return (
    <Badge
      variant="outline"
      className="flex flex-row h-auto overflow-visible p-1 px-2 text-center items-center gap-x-1"
    >
      <motion.button
        onClick={() => setAlertsTray(true)}
        variants={{
          pulse: {
            scale: [1, 1.05, 1, 1.05, 1, 1, 1, 1, 1],
          },
        }}
        animate={currentRequests ? "pulse" : ""}
        transition={{
          repeat: Infinity,
          repeatType: "loop",
          delay: 2,
          duration: 2,
        }}
        type="button"
        id="headerServiceRequestAlertButton"
        data-tip="Help Requests"
        data-for="headerButtonsTooltip"
      >
        <ServiceRequestIcon
          class={`size-4 mr-1.5 ${
            currentRequests
              ? "text-red-500 dark:text-red-500"
              : "text-green-500 dark:text-green-500"
          }`}
        />
        <span
          className={`${
            currentRequests
              ? "text-red-500 dark:text-red-500"
              : "text-text-muted"
          } text-xs font-medium pr-1 pt-1`}
        >
          {currentFacilityServiceReqests.length > 1
            ? currentFacilityServiceReqests.length + " alerts"
            : "No alerts"}
        </span>
      </motion.button>
    </Badge>
  );
};

export default ServiceRequestAlert;

type Props = {
  title?: string;
};
